var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InitialBanner',{attrs:{"image":"bg_banner_faq_page_1.png","imageTitle":"faq.banner_title"}}),_c('div',{staticClass:"faq-bg-page"},[_c('div',{staticClass:"container-default"},[_c('FaqContent')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }